import _ from 'lodash';
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons/faEllipsisH';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

export default class InlineImageAttachment extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleLoad = this.handleLoad.bind(this);
    this.state = { isLoaded: false };
  }

  render() {
    const { attachmentId, onClick, inlinePreviewImageUrl } = this.props;

    const handleClick = this.state.isLoaded ? onClick : _.noop;
    const imageStyle = this.state.isLoaded ? undefined : { display: 'none' };
    return (
      <li className="inlineImageAttachment" onClick={handleClick} key={attachmentId}>
        {this.state.isLoaded ? null : <PlaceholderInlineImage />}
        <img
          className="inlineImageAttachment-image"
          onLoad={this.handleLoad}
          src={inlinePreviewImageUrl}
          style={imageStyle}
          ref={image => (this.image = image)}
        />
      </li>
    );
  }

  handleLoad(evt) {
    this.setState({ isLoaded: true }, () => {
      this.props.onLoad && this.props.onLoad();
    });
  }
}

InlineImageAttachment.propTypes = {
  attachmentId: PropTypes.string.isRequired,
  inlinePreviewImageUrl: PropTypes.string,
  onClick: PropTypes.func,
  onLoad: PropTypes.func,
};

export function PlaceholderInlineImage() {
  return (
    <div className="inlineImageAttachment-placeholder">
      <FontAwesomeIcon icon={faEllipsisH} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/attachment/inline_image_attachment.jsx